import React, { FC } from 'react'

const SpinnerIcon: FC = () => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_690_553" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="16" y="4" width="7" height="9">
      <path
        d="M16.7676 6.45036L18.5988 4.0741C20.9815 5.91027 22.5032 8.79591 22.5005 12.0006H19.5004C19.5026 9.75938 18.4411 7.74006 16.7676 6.45036Z"
        fill="url(#paint0_linear_690_553)"
      />
    </mask>
    <g mask="url(#mask0_690_553)">
      <rect x="1.5" y="1.00061" width="22" height="22" fill="white" />
    </g>
    <mask
      id="mask1_690_553"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="12"
      y="12"
      width="11"
      height="11"
    >
      <path
        d="M12.5 19.0004C16.2006 19.0035 19.2946 16.1046 19.4905 12.3666C19.4969 12.244 19.5001 12.122 19.5002 12.0006H22.5003C22.5002 12.174 22.4955 12.3484 22.4864 12.5236C22.2065 17.8636 17.7866 22.005 12.5 22.0005V19.0004Z"
        fill="url(#paint1_linear_690_553)"
      />
    </mask>
    <g mask="url(#mask1_690_553)">
      <rect x="1.5" y="1.00061" width="22" height="22" fill="white" />
    </g>
    <mask
      id="mask2_690_553"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="2"
      y="12"
      width="11"
      height="11"
    >
      <path
        d="M12.1339 18.9906C12.2566 18.9971 12.3787 19.0003 12.5002 19.0004V22.0005C12.3266 22.0003 12.1522 21.9957 11.9769 21.9865C6.63705 21.7067 2.49574 17.287 2.5 12.0006H5.50008C5.49716 15.701 8.39605 18.7947 12.1339 18.9906Z"
        fill="url(#paint2_linear_690_553)"
      />
    </mask>
    <g mask="url(#mask2_690_553)">
      <rect x="1.5" y="1.00061" width="22" height="22" fill="white" />
    </g>
    <mask
      id="mask3_690_553"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="2"
      y="2"
      width="13"
      height="11"
    >
      <path
        d="M12.8666 5.00984C9.0059 4.80751 5.71217 7.7732 5.50984 11.6339C5.5034 11.7567 5.50017 11.879 5.50007 12.0006H2.5C2.50014 11.827 2.50475 11.6523 2.51395 11.4769C2.80299 5.96161 7.50833 1.72491 13.0236 2.01395C13.8509 2.05731 14.4864 2.76311 14.443 3.5904C14.3997 4.41769 13.6939 5.0532 12.8666 5.00984Z"
        fill="url(#paint3_linear_690_553)"
      />
    </mask>
    <g mask="url(#mask3_690_553)">
      <rect x="1.5" y="1.00061" width="22" height="22" fill="white" />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_690_553"
        x1="19.5002"
        y1="12.0006"
        x2="16.5002"
        y2="4.00061"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity="0.08" />
        <stop offset="1" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_690_553"
        x1="12.5"
        y1="19.0006"
        x2="19.5"
        y2="12.0006"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity="0.35" />
        <stop offset="1" stopOpacity="0.08" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_690_553"
        x1="5.50018"
        y1="12.0006"
        x2="12.5002"
        y2="19.0006"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity="0.65" />
        <stop offset="1" stopOpacity="0.35" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_690_553"
        x1="14.5002"
        y1="5.00064"
        x2="5.50018"
        y2="12.0006"
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset="1" stopOpacity="0.65" />
      </linearGradient>
    </defs>
  </svg>
)

export default SpinnerIcon
